import React, { Component } from 'react';
import browserStorage from '../../../../common/services/browserStorage';

class AuthorizationRedirect extends Component {
	componentDidMount() {
		const { franchisor, useSandbox, paymentConfigurationId, paymentOwnerType, paymentOwnerId, franchiseeId } = this.props;
		// store required data in local storage and pass the local storage key as Stripe state param
		const storedData = {
			useSandbox,
			paymentConfigurationId,
			paymentOwnerType,
			paymentOwnerId,
			franchiseeId
		};
		const storedDataKey = Math.random().toString(36).substr(2);
		browserStorage.setToSessionStorage(franchisor, storedDataKey, JSON.stringify(storedData));

		const authorizeUrl = 'https://connect.stripe.com/oauth/authorize';
		const clientId = useSandbox ? franchisor.stripeSandboxClientId : franchisor.stripeLiveClientId;
		const redirectUrl = franchisor.stripeOAuthRedirectUrl;

		window.location = `${authorizeUrl}?response_type=code&scope=read_write` +
			`&client_id=${clientId}` +
			`&redirect_uri=${encodeURIComponent(redirectUrl)}` +
			`&state=${encodeURIComponent(storedDataKey)}`;
	}

	render() {
		return <div>Redirecting...</div>;
	}
}

export default AuthorizationRedirect;